b247.user_status = function() {

  var header_user = $('[data-header-user]'),
  header_user_out = $('[data-header-user-out]');

  $.ajax({
    method: 'post',
    url: ajax_url,
    data: {
      'action' : 'is_user_logged_in'
    },
    success:function(data) {

      if (data.success) {

        if (data.state) {

          header_user_out.remove();
          header_user.append('<p class="header__user__in">' + data.name + ' (<a href="' + data.url + '" class="header__user__link">Sign out</a>)</p>');

        } else {



        }

      }

    }
  });

};
